module.exports = __webpack_public_path__ + "static/media/vf_wshoes_core.ec36564c.svg";